export const EXTENSION_TYPE = 'com.atlassian.confluence.native';
export const EXTENSION_KEY = 'native-tabs';
export const DEFAULT_TAB_COUNT = 2;

/**
 * Returns the default display title for a tab at a given zero-based index.
 * Not i18n'd — this is an ADF document default, not a displayed UI string.
 */
export const getDefaultTabTitle = (index: number): string => `Tab ${index + 1}`;
